module.exports = __webpack_public_path__ + "img/cooler_des_2.7dffed82.jpg";